import React from "react";
import { projects } from "../data/siteData";
import useScrollReveal, { revealUp } from "../hooks/useScrollReveal";
import "./Projects.css";

export default function Projects() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".projects__card"), {
      ...revealUp(null, el.querySelector(".projects__grid")),
      stagger: 0.1,
    });
  }, []);

  return (
    <section id="projects" className="projects section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">Selected Work</span>
        <h2 className="projects__title">
          PROJECTS <span className="accent-text">WE'VE DELIVERED</span>
        </h2>

        <div className="projects__grid">
          {projects.map((p, i) => (
            <article className="projects__card" key={p.id}>
              <div
                className="projects__card-image"
                style={p.image ? { backgroundImage: `url(${p.image})` } : undefined}
              />
              <div className="projects__card-meta">
                <span className="projects__card-number">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3>{p.type}</h3>
                <p>
                  {p.location} — {p.capacity} — {p.year}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
